import { render, staticRenderFns } from "./RegionConfigIndex.vue?vue&type=template&id=31938df4&scoped=true&"
import script from "./RegionConfigIndex.vue?vue&type=script&lang=js&"
export * from "./RegionConfigIndex.vue?vue&type=script&lang=js&"
import style0 from "./RegionConfigIndex.vue?vue&type=style&index=0&id=31938df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31938df4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31938df4')) {
      api.createRecord('31938df4', component.options)
    } else {
      api.reload('31938df4', component.options)
    }
    module.hot.accept("./RegionConfigIndex.vue?vue&type=template&id=31938df4&scoped=true&", function () {
      api.rerender('31938df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/engineers/RegionConfigIndex.vue"
export default component.exports